export const isFunction = (value) => typeof value === "function";
export const isArray = (value) => Array.isArray(value);
export const isObject = (value) =>
  value && typeof value === "object" && value.constructor === Object;
